import React from 'react';
import { ITelemetry } from '../telemetry';
import { IComponent } from './qos/types';

export interface ITelemetryContextProps {
  /**
   * The telemetry instance
   */
  readonly telemetry: ITelemetry;
  /**
   * Register the component to the first meaningful content
   */
  readonly registerToFirstMeaningfulContent: (component: IComponent) => void;
  /**
   * Unregister the component from the first meaningful content. If it reaches 0 then it means the first meaningful content is loaded without error and
   * will calculate and log timestamp of First Meaningful Paint (FMP)
   */
  readonly unRegisterToFirstMeaningfulContent: (component: IComponent) => void;

  readonly setTelemetry: React.Dispatch<React.SetStateAction<ITelemetry>>;
}

export const TelemetryContext = React.createContext<ITelemetryContextProps | undefined>(undefined);
